import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const PassengerIconBlue: FC<IconProps> = ({ width = 12, height = 22, ...rest }) => (
  <Icon type="PassengerBlue" width={width} height={height} alt="PassengerIconBlue" {...rest} />
)
